import {DateEntity} from '../entities/Date';

export const getDefaultExpireTime = () => {
	const currentDate = new Date();
	currentDate.setMinutes(currentDate.getMinutes() + 1);
	return new DateEntity(currentDate);
};
